const hasTimezone = (timezoneKey) => {
  return {
    getTimezoneName() {
      switch (timezoneKey) {
        case 'America/Anchorage':
          return 'Alaska';
        case 'America/Chicago':
          return 'Central';
        case 'America/New_York':
          return 'Eastern';
        case 'Pacific/Honolulu':
          return 'Hawaii';
        case 'America/Denver':
          return 'Mountain';
        case 'America/Phoenix':
          return 'Mountain/Pacific (Arizona)';
        case 'America/Los_Angeles':
          return 'Pacific';
        default:
          return 'Unknown Timezone';
      }
    },
  };
};

export default hasTimezone;
